import { redirect } from 'react-router';
import { ROUTER_PATH } from '@constants/routerItems.constant';
import { tokenService } from '@core/services/Token.service';
import type { TToken } from '@core/models/tokenService.model';
import type { TNullable } from '@core/models/utility.model';
import type { LoaderFunctionArgs } from 'react-router';

const loginTokenVerificationLoader = async ({
  request
}: LoaderFunctionArgs<null>): Promise<TNullable<Response>> => {
  const url = new URL(request.url);
  const accessToken = url.searchParams.get('accessToken');
  const refreshToken = url.searchParams.get('refreshToken');

  if (accessToken && refreshToken) {
    const tokens: TToken = {
      accessToken,
      refreshToken
    };
    tokenService.setTokens(tokens);

    return redirect(ROUTER_PATH.base);
  }

  return null;
};

export { loginTokenVerificationLoader };
